export default __webpack_public_path__ + "static/media/bangaloreImage.1829a16b.svg";